import { render, staticRenderFns } from "./MyQuestionnaireList.vue?vue&type=template&id=194b67b9"
import script from "./MyQuestionnaireList.vue?vue&type=script&lang=js"
export * from "./MyQuestionnaireList.vue?vue&type=script&lang=js"
import style0 from "./MyQuestionnaireList.vue?vue&type=style&index=0&id=194b67b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports